<template>
  <v-flex xs12 row>
  	<v-layout row wrap>
  		<v-flex xs12>
  			
  		</v-flex>
  	</v-layout>

	<v-layout py-3>
   		<v-flex xs12 sm10 offset-sm1>
   			<v-card>
	   			<v-card-title>

		          <autocomplete v-model="filter.module_id" :items="modules" search-key="module" label="Module" />

		          <v-autocomplete v-model="filter.role_id" :items="roles" item-text="role" item-value="id" label="Role" class="mr-3"></v-autocomplete>

		          <search-btn @click="filterData" />

			      <v-spacer></v-spacer>
			      
			      <v-dialog v-model="dialog" max-width="600px">
			        <v-card>
			          <v-card-title>
			            <span class="headline">Update Access</span>
			          </v-card-title>

			          <v-card-text>
			            <v-container grid-list-md py-0>
			              <v-layout wrap>
			                <v-flex xs12 sm6>
			                  <v-text-field readonly v-model="item.module" label="Module"></v-text-field>
			                </v-flex>
			                <v-flex xs12 sm6>
			                  <v-text-field readonly v-model="item.role" label="Role"></v-text-field>
			                </v-flex>
			                <v-flex xs12 sm6>
			                  <v-checkbox label="Create" v-model="item.is_create_allowed"></v-checkbox>
			                </v-flex>
			                <v-flex xs12 sm6>
			                  <v-checkbox label="Read" v-model="item.is_read_allowed"></v-checkbox>
			                </v-flex>
			                <v-flex xs12 sm6>
			                  <v-checkbox label="Update" v-model="item.is_update_allowed"></v-checkbox>
			                </v-flex>
			                <v-flex xs12 sm6>
			                  <v-checkbox label="Delete" v-model="item.is_delete_allowed"></v-checkbox>
			                </v-flex>
			              </v-layout>
			            </v-container>
			          </v-card-text>

			          <v-card-actions>
			            <v-spacer></v-spacer>
			            <v-btn color="blue darken-1" flat :disabled="processing" @click.native="close">Cancel</v-btn>
			            <v-btn color="blue darken-1" flat :disabled="processing" @click.native="updateItem">Update</v-btn>
			          </v-card-actions>
			        </v-card>
			      </v-dialog>

			    </v-card-title>
	   			<v-data-table
				    :headers="headers"
				    :loading="processing"
				    :items.sync="moduleAccesses"
				    :search="search"
				    v-model="selected"
				    item-key="id"
      				hide-actions
      				disable-initial-sort
				  >
				  	<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
				    <template slot="headerCell" slot-scope="props">
				      <v-tooltip bottom>
				        <span slot="activator">
				          {{ props.header.text }}
				        </span>
				        <span>
				          {{ props.header.text }}
				        </span>
				      </v-tooltip>
				    </template>
				    <template slot="items" slot-scope="props">
				      <td>{{ props.item.module }}</td>
				      <td>{{ props.item.role }}</td>
				      <td>
				      	<v-icon small :color="props.item.is_create_allowed ? 'success' : 'error'" v-text="props.item.is_create_allowed ? 'done' : 'clear'"></v-icon>
				      </td>
				      <td>
				      	<v-icon small :color="props.item.is_read_allowed ? 'success' : 'error'" v-text="props.item.is_read_allowed ? 'done' : 'clear'"></v-icon>
				      </td>
				      <td>
				      	<v-icon small :color="props.item.is_update_allowed ? 'success' : 'error'" v-text="props.item.is_update_allowed ? 'done' : 'clear'"></v-icon>
				      </td>
				      <td>
				      	<v-icon small :color="props.item.is_delete_allowed ? 'success' : 'error'" v-text="props.item.is_delete_allowed ? 'done' : 'clear'"></v-icon>
				      </td>
				      <td class="align-center justify-center layout px-0">
				      	<v-icon small class="mr-1" @click="editItem(props.item)" v-if="props.item.is_editable && hasEditAccess">edit</v-icon>
				      </td>
				    </template>
				    <template slot="no-data" v-if="!processing">
				      <v-alert :value="true" color="error" icon="warning">
				        Sorry, nothing to display here :(
				      </v-alert>
				    </template>
				  </v-data-table>

				  <v-pagination @loadPage="loadPage" />
				  
			</v-card>
   		</v-flex>
   	</v-layout>
    
  </v-flex>
</template>

<script>

  export default {
    name: 'ModuleAccesses',
    data () {
      return {
      	title: "View Role Accesses",
      	processing: false,
      	moduleAccesses: [],
        search: '',
        selected: [],
        headers: [
          { text: 'Module', value: 'module'},
          { text: 'Role', value: 'role' },
          { text: 'Create', value: 'is_create_allowed' },
          { text: 'Read', value: 'is_read_allowed' },
          { text: 'Update', value: 'is_update_allowed' },
          { text: 'Delete', value: 'is_delete_allowed' },
          { text: 'Actions', value: 'id', sortable: false }
        ],
        item: {},
        dialog: false,
        filter: {
          module_id: "",
          role_id: ""
        },
        modules: [{id: "", module: "All"}],
        roles: [{id: "", role: "All"}]
      }
    },
    methods: {

    	loadPage () {

    		let api_path = this.config.apis.viewModuleAccesses.replace(":page", this.currentPage).replace(":perPage", this.paginationOptions.rowsPerPage)
	        
	        let filterArray = []

	        for (const [key, val] of Object.entries(this.filter)) {
	          filterArray.push(`${key}=${val}`)
	        }

	        api_path += '?' + filterArray.join('&')

    		this.processing = true
	        this.axios.get(api_path)
	          .then((response) => {
	            this.processing = false
	            if (this.isSuccessResponse(response)) {
	            	
	            	this.$store.commit('setItemsCount', response.data.data.total)
	            	
	            	this.moduleAccesses = response.data.data.items
	            }
	            else{
	            	this.moduleAccesses = []
	            	this.$store.commit('setItemsCount', 0)
	            }
	          })
	          .catch((error) => {
	            this.processing = false
	          })
    	},

		updateItem: function(){
			this.processing = true
			this.axios.put(this.config.apis.updateModuleAccess.replace(":id", this.item.id), this.item)
			  .then((response) => {
			    if (this.isSuccessResponse(response)) {
	              this.notifySuccess('updateSuccess')
	              this.close()
	            }
	            else{
	              this.notifyError('updateError')
	            }
	            this.processing = false
			  })
			  .catch((error) => {
			    this.processing = false
			  })
		},

      	close () {
        	this.dialog = false
        	setTimeout(() => {
          		this.item = {}
        	}, 300)
      	},

      	editItem (item) {
	        this.item = item
	        this.dialog = true
	    }

    },
    created () {
    	let breadcrumbs = [
	      	{
	          text: 'Dashboard',
	          disabled: false,
	          href: '/dashboard'
	        },
	        {
	          text: 'Modules',
	          disabled: false,
	          href: '/modules'
	        },
	        {
	          text: 'Module Access',
	          disabled: true
	        }
       ]

       this.$store.commit('setBreadcrumbs', breadcrumbs)
       this.$store.commit('setPageTitle', 'Manage Module Access')
    },
    mounted () {
    	
    	this.getAllData('module')
	        .then((response) => {
	          this.modules = this.modules.concat(response)
	        })

	    this.getAllData('adminrole')
	        .then((response) => {
	          this.roles = this.roles.concat(response)
	        })
    },

    computed: {

    }

  }
</script>
